import { OrderItem } from './Order';
import { Return } from './Return';

export enum ReturnReason {
  DAMAGED = "damaged",
  WRONG_ITEM = "wrong_item",
  NOT_AS_DESCRIBED = "not_as_described",
  NO_LONGER_NEEDED = "no_longer_needed",
  DEFECTIVE = "defective",
  OTHER = "other",
}

export const translateReturnReason = (reason: ReturnReason): string => {
  switch (reason) {
    case ReturnReason.DAMAGED:
      return "Uszkodzony";
    case ReturnReason.WRONG_ITEM:
      return "Niewłaściwy produkt";
    case ReturnReason.NOT_AS_DESCRIBED:
      return "Niezgodny z opisem";
    case ReturnReason.NO_LONGER_NEEDED:
      return "Już niepotrzebny";
    case ReturnReason.DEFECTIVE:
      return "Wadliwy";
    case ReturnReason.OTHER:
      return "Inny powód";
  }
};

export interface ReturnItem {
  id: string;
  returnId: string;
  orderItemId: string;
  quantity: number;
  reason: ReturnReason;
  description?: string;
  createdAt: Date;
  updatedAt: Date;
  
  // Relacje
  return?: Return;
  orderItem?: OrderItem;
}

export interface ReturnItemCreationAttributes {
  orderItemId: string;
  quantity: number;
  reason: ReturnReason;
  description?: string;
}
